<div class="kw-page" [nbSpinner]="this.isLoading">

  <button mat-button class="back-btn" type="button" (click)="back()">
    <fa-icon [icon]="faArrowLeft" class="me-2"></fa-icon>Back
  </button>

  <ng-container *ngIf="this.item">

    <div class="detail-card detail-hero">
      <div class="hero-left">
        <div class="hero-avatar"><fa-icon [icon]="faBox"></fa-icon></div>
        <div class="hero-info">
          <h1 class="hero-title">
            {{this.item.name}}
            <span class="inactive-pill" *ngIf="this.item.isActive === false">Inactive</span>
          </h1>
          <p class="hero-subtitle" *ngIf="this.item.description">{{this.item.description}}</p>
          <div class="hero-meta">
            <span class="meta-item" *ngIf="this.item.varietyName">
              <fa-icon [icon]="faSeedling" class="meta-icon"></fa-icon>{{this.item.varietyName}}
            </span>
            <span class="meta-item" *ngIf="this.item.packageTypeName">
              <fa-icon [icon]="faBoxOpen" class="meta-icon"></fa-icon>{{this.item.packageTypeName}}
            </span>
            <span class="meta-item" *ngIf="this.item.parentItemName">
              <fa-icon [icon]="faSitemap" class="meta-icon"></fa-icon>{{this.item.parentItemName}}
            </span>
          </div>
          <div class="hero-pills" *ngIf="this.item.varietyIsOrganic || this.item.isReceivingItem">
            <span class="type-pill" *ngIf="this.item.varietyIsOrganic">Organic</span>
            <span class="type-pill" *ngIf="this.item.isReceivingItem">Receiving</span>
          </div>
        </div>
      </div>

      <div class="hero-actions">
        <button mat-raised-button color="primary" class="primary-action" type="button" (click)="editItem()">
          <fa-icon [icon]="faPen" class="me-2"></fa-icon>Edit {{"Product" | tenantWords}}
        </button>
      </div>
    </div>

    <div class="detail-main">
      <div class="detail-column">
        <div class="detail-card info-card">
          <div class="card-bar">
            <h3>Details</h3>
          </div>
          <div class="info-grid">
            <div class="info-row"><span class="k">Name</span><span class="v">{{this.item.name || '—'}}</span></div>
            <div class="info-row"><span class="k">Description</span><span class="v">{{this.item.description || '—'}}</span></div>
            <div class="info-row"><span class="k">Variety</span><span class="v">{{this.item.varietyName || '—'}}</span></div>
            <div class="info-row"><span class="k">Parent {{"Product" | tenantWords}}</span><span class="v">{{this.item.parentItemName || '—'}}</span></div>
          </div>
        </div>

        <div class="detail-card info-card" *ngIf="this.item.packageTypeId">
          <div class="card-bar">
            <h3>Package</h3>
          </div>
          <div class="info-grid">
            <div class="info-row"><span class="k">Package Type</span><span class="v">{{this.item.packageTypeName || '—'}}</span></div>
            <div class="info-row"><span class="k">Unit of Measure</span><span class="v">{{this.item.packageUnitOfMeasure || '—'}}</span></div>
            <div class="info-row"><span class="k">Qty per Pallet</span><span class="v">{{(this.item.packageQuantityPerPallet | number) || '—'}}</span></div>
            <ng-container *ngIf="this.item.packageHasComponents">
              <div class="info-row"><span class="k">Component</span><span class="v">{{this.item.packageComponentName || '—'}}</span></div>
              <div class="info-row"><span class="k">Components per Package</span><span class="v">{{(this.item.packageComponentQuantityPerPackage | number) || '—'}}</span></div>
            </ng-container>
          </div>
        </div>

        <div class="detail-card info-card" *ngIf="this.item.attributes?.length">
          <div class="card-bar">
            <h3>Attributes</h3>
            <span class="count-pill">{{this.item.attributes.length}}</span>
          </div>
          <div class="info-grid">
            <div class="info-row" *ngFor="let attr of this.item.attributes; trackBy: trackByAttribute">
              <span class="k">{{attr.name}}</span><span class="v">{{attr.value ?? '—'}}</span>
            </div>
          </div>
        </div>
      </div>

      <inventory-transaction-timeline [transactions]="this.item.transactions"></inventory-transaction-timeline>
    </div>

  </ng-container>
</div>
